(function () {
    'use strict';

    angular
        .module('app')
        .factory('gridDataService', gridDataService);

    // workAreaService would be a circular dependency. So, use injector.
    gridDataService.$inject = ['$http', '$injector', '$q', '$timeout', 'loginService'];

    function gridDataService($http, $injector, $q, $timeout, loginService) {
        var service = this;
        service.serviceIdentifier = "";
        service.startRecord = 1;
        service.endRecord = 100;
        service.currentPage = 1;
        service.totalPages = 0;
        service.onSelectedRecordChanged = function () { } //empty function placeholder
        service.onRecordCountsChanged = function () { }
        service.totalRecords = 0;
        service.data = [];
        service.ddData = [];
        service.counting = false;
        service.exportColumns = [];
        service.columDefs = [];
        service.reloadGrid = {};
        service.getDataOperation = {};
        service.getCountOperation = {};
        service.callBacks = [];
        service.menuEnables = {};
        service.menuEnablesDD = {};
        service.selectedRows = [];
        service.initialLoading = false;
        service.selectionCallbacks = [];
        service.updateRecordsCallbacks = [];
        service.currentService = {};
        service.refreshGrid = {};

        service.rowsToAdd = []; // pl

        //registers a callback to be notified when data fetching is complete.
        service.register = function (callBack) {
            service.callBacks.push(callBack);
        }
        //unregister a callback
        service.unRegister = function (callBack) {
            angular.forEach(service.callBacks, function (item, key) {
                if (callBack === callBack) {
                    service.callBacks.splice(key, 1);
                }
            });
        }

        service.close = function () {
            service.data = [];
            service.ddData = [];
            service.startRecord = 1;
            service.endRecord = 100;
            service.callBacks = [];
            service.selectionCallbacks = [];
        }

        service.getData = function (skip, take, sort, sortDirection, currentPage) {
            service.processing = true;
            service.data = [];

            service.pageSizeLabel = loginService.resourceStrings["PAGE_SIZE"]; // "Page Size"
            service.gridSettingsLabel = loginService.resourceStrings["GRID_SETTINGS"]; // "Grid Settings"
            service.noRecordsFoundLabel = loginService.resourceStrings["NO_RECORDS_FOUND"]; // "No records found"
            service.loadingDataLabel = loginService.resourceStrings["LOADING_DATA"]; // "Loading Data"
            service.firstPageLabel = loginService.resourceStrings["FIRST_PAGE"]; // "First Page"
            service.previousPageLabel = loginService.resourceStrings["PREVIOUS_PAGE"]; // "Previous Page"
            service.nextPageLabel = loginService.resourceStrings["NEXT_PAGE"]; // "Next Page"
            service.lastPageLabel = loginService.resourceStrings["LAST_PAGE"]; // "Last Page"
            service.ofLabel = loginService.resourceStrings["OF"]; // "of"
            service.recordsLabel = loginService.resourceStrings["RECORDS"]; // "records"

            //set the initial loading flag if it's a brand new operation.
            if (service.totalRecords == 0) {
                service.initialLoading = true;
                skip = 0; // If no records, then skip cannot be greater than zero.
            }
            var d = $q.defer();
            $timeout(function () {
                var genericDataService = $injector.get(service.serviceIdentifier);
                service.currentService = $injector.get(service.serviceIdentifier);
                var getType = {};
                //cancel previous operations
                if (getType.toString.call(service.getDataOperation.cancel) === '[object Function]') {
                    service.getDataOperation.cancel();
                }

                //do not count
                var response = genericDataService.getData(skip, take, service.totalRecords, sort, sortDirection, false);

                //process the results
                var processResults = function (result) {
                    if (service.totalRecords == 0) {
                        service.totalRecords = result.data.AdeptDataTable.RecordCount;
                    }



                    service.processing = false;


                    service.currentPage = currentPage;
                    service.data = result.data.AdeptDataTable.TableRecords;
                    service.menuEnables = result.data.MenuEnables;

                    d.resolve(result);
                    var getType = {};
                    if (service.onGridReloaded && getType.toString.call(service.onGridReloaded) === '[object Function]') {
                        service.onGridReloaded();
                    }
                    //notify any callbacks registered
                    angular.forEach(service.callBacks, function (callBack) {
                        callBack();
                    });
                }

                response.promise.then(function (result) {
                    service.getDataOperation = {};
                    if (!result.data.AdeptDataTable.TableRecords) {
                        result.data.AdeptDataTable.TableRecords = [];
                    }
                    service.initialLoading = false;
                    processResults(result);
                }, function (response) {
                    $timeout(function () {
                        service.processing = false;
                    });

                    service.totalRecords = 0;
                    d.reject(response);
                    ////if we ended the operation because it took to long then get the records without take and skip.
                    //if (response.config.timeout.$$state.value == "timeout") {
                    //    ////get the records without take and skip
                    //    //var secondTry = genericDataService.getData(skip, take, -1, sort, sortDirection, false);
                    //    //secondTry.promise.then(function (response) {
                    //    //    processResults(response);
                    //    //})
                    //}
                    //else {
                    //    service.processing = false;
                    //    service.totalRecords = 0;
                    //    d.reject(response)
                    //}

                });

                service.getDataOperation = response;
            })


            return d.promise;
        };


        service.exportCsv = function (skip, take, sort, sortDirection, columns) {
            var deferred = $q.defer();
            var genericDataService = $injector.get(service.serviceIdentifier);
            var response = genericDataService.getData(skip, take, service.totalRecords, sort, sortDirection, false, 2, columns).promise.then(function (response) {
                deferred.resolve(response);
            });
            return deferred.promise;
        }

        service.exportExcel = function (skip, take, sort, sortDirection, columns) {
            var deferred = $q.defer();
            var genericDataService = $injector.get(service.serviceIdentifier);
            var response = genericDataService.getData(skip, take, service.totalRecords, sort, sortDirection, false, 3, columns).promise.then(function (response) {
                deferred.resolve(response);
            });
            return deferred.promise;
        }

        //registers a callback for record selection
        service.onRecordSelected = function (callBack) {
            var alreadyRegistered = false;
            //figure out if the callback has already been registered
            angular.forEach(service.selectionCallbacks, function (item) {
                if ('' + item == '' + callBack) {
                    alreadyRegistered = true;
                }
            });
            //do not add the callback if it has already been registered
            if (!alreadyRegistered) {
                service.selectionCallbacks.push(callBack);
            }
        }
        // unregister a callback for record selection
        service.onRecordSelectedUnsubscribe = function (callBack) {
            angular.forEach(service.selectionCallbacks, function (item) {
                if ('' + item == '' + callBack) {
                    service.selectionCallbacks.splice(service.selectionCallbacks.lastIndexOf(item), 1);
                }
            });
        }

        //registers callbacks for record updating
        service.registerOnUpdateRecords = function (callBack) {
            //var alreadyRegistered = false;
            //figure out if the callback has already been registered
            //angular.forEach(service.updateRecordsCallbacks, function (item) {
            //    if (''+item === ''+callBack) {
            //        alreadyRegistered = true;
            //    }
            //});
            //do not add the callback if it has already been registered
            //if (!alreadyRegistered) {
            service.updateRecordsCallbacks.push(callBack);
            //}
        }

        //method to call when a record is selected.
        service.recordSelected = function (records) {
            service.selectedRows = records;
            angular.forEach(service.selectionCallbacks, function (callback) {
                callback(service.selectedRows);
            });
        }

        service.recordsUpdated = function () {
            angular.forEach(service.selectionCallbacks, function (callback) {
                if (service.selectedRows.length > 0) {
                    callback(service.selectedRows);
                }
            });
        }


        service.recordSelectedDD = function (records) {
            if (records.length == 0 && service.currentFocus == "main") {
                return;
            }
            service.selectedRows = records;
        }

        service.getCount = function () {
            var d = $q.defer();
            if (service.totalRecords == 0 || service.totalRecords == -1) {
                service.counting = true;

                $timeout(function () {
                    var genericDataService = $injector.get(service.serviceIdentifier);

                    var getType = {};
                    //cancel previous count operation
                    if (getType.toString.call(service.getCountOperation.cancel) === '[object Function]') {
                        service.getCountOperation.cancel();
                    }

                    //count operation
                    var response = genericDataService.getCount();
                    response.then(function (count) {
                        service.totalRecords = count;
                        d.resolve(count);
                        service.counting = false;
                        service.getCountOperation = {};
                    }, function (response) {
                        service.totalRecords = 0;
                        d.reject(response)
                    });

                    service.getCountOperation = response;
                })
            }
            else {
                d.resolve(service.totalRecords);
            }


            return d.promise;
        }

        //this method will update the grid's data by taking a map of the old record and the new record as a parameter
        service.replaceRecordsMain = function (records) {
            angular.forEach(records, function (record, index) {
                var old = record.oldRecord;
                var newRecord = record.newRecord;

                //iterate the grid records and update them
                angular.forEach(service.data, function (item, index) {
                    if (old.docId == item.SCHEMA_S_FILEID && old.majRev == item.SCHEMA_S_MAJREV && old.minRev == item.SCHEMA_S_MINREV) {
                        if (newRecord.SCHEMA_S_FILEID) {
                            //console.log("old record: ", item);
                            //console.log("new record", newRecord);
                            service.data[index] = newRecord;
                        }
                        else {
                            service.data.splice(index, 1);
                        }
                    }
                });
            });
        }

        //this method will update the dd grid's data by taking a map of the old record and the new record as a parameter
        service.replaceRecordsDD = function (records) {
            angular.forEach(records, function (record, index) {
                var old = record.oldRecord;
                var newRecord = record.newRecord;

                //iterate the dd records and update them
                angular.forEach(service.ddData, function (item, index) {
                    if (old.docId == item.SCHEMA_S_FILEID && old.majRev == item.SCHEMA_S_MAJREV && old.minRev == item.SCHEMA_S_MINREV) {
                        if (newRecord.SCHEMA_S_FILEID) {
                            service.ddData[index] = newRecord;
                        }
                        else {
                            service.ddData.splice(index, 1);
                        }
                    }
                });
            });
        }


        service.removeRecords = function (records) {
            console.log("need to remove records", records);
        }

        service.appendItem = function (item, si, siDD, recordsToUpdate, recordsToUpdateDD) {
            // 2018-01-03 If we didn't set it, then don't do it, otherwise "none" won't be respected and will cause a "remove".
            ////Ensure we don't blow up later on.
            //if (!si) {
            //    si = { fileId: null, majRev: null, minRev: null };
            //}
            //if (!siDD) {
            //    siDD = { fileId: null, majRev: null, minRev: null };
            //}
            if (si != null) {
                recordsToUpdate.push({
                    newRecord: {
                        docId: si.fileId,
                        majRev: si.majRev,
                        minRev: si.minRev
                    },
                    oldRecord: {
                        docId: item.fileId,
                        majRev: item.majRev,
                        minRev: item.minRev
                    }
                });
            }
            if (siDD != null) {
                recordsToUpdateDD.push({
                    newRecord: {
                        docId: siDD.fileId,
                        majRev: siDD.majRev,
                        minRev: siDD.minRev
                    },
                    oldRecord: {
                        docId: item.fileId,
                        majRev: item.majRev,
                        minRev: item.minRev
                    }
                });
            }

            if (si.docId == "remove") {
                var ddService = $injector.get('ddService');
                var gridDataService = $injector.get('gridDataService');
                //if (ddService.currentRecord != null && ddService.currentRecord.childId != null && ddService.currentRecord.childId.length > 0) {
                //    if (ddService.currentRecord.childId == item.fileId)
                //        gridDataService.recordSelected(null);
                //}
                ddService.currentRecord = {};
                ddService.data = [];
                //gridDataService.recordSelected([]);
            }
        }

        //this method will update the grid's records
        service.updateGridRecords = function (list) {
            //construct a list of keys to update the grid
            var recordsToUpdate = [];
            var recordsToUpdateDD = [];

            service.rowsToAdd = []; // pl

            //create a map of the old record and new record keys
            angular.forEach(list, function (item) {

                var updateMode_None = 0;
                var updateMode_Update = 1;
                var updateMode_Remove = 2;
                var updateMode_Replace = 3;
                var updateMode_Add = 4;
                var si = null;
                var siDD = null;

                // If anyone calls without any selection command update info,
                //  just fall back on a standard update.
                if (item.updateMode == null)
                {
                    item.updateMode = updateMode_Update;
                    item.updateSI = item;
                }

                //check to see if we're in the workarea
                if (service.serviceIdentifier == 'workAreaService') {
                    
                    var workAreaItem = item;
                    if (item.workAreaSI != null)
                        workAreaItem = item.workAreaSI;

                    switch (item.workAreaUpdateMode) {
                        case updateMode_Replace:
                            si = item.workAreaReplaceWithSI;
                            siDD = item.updateSI;
                            break;
                        case updateMode_Remove:
                            si = { docId: "remove", majRev: "", minRev: "" };
                            siDD = item.updateSI;

                            // Update rec counts.
                            service.endRecord = service.endRecord - 1;
                            if (service.endRecord == 0)
                                service.startRecord = 0;
                            service.totalRecords = service.totalRecords - 1;
                            service.onRecordCountsChanged();

                            break;
                        case updateMode_Update:
                            si = item.workAreaSI;
                            siDD = item.updateSI;
                            break;
                        case updateMode_Add: // pl
                            var workAreaService = $injector.get('workAreaService');
                            if (workAreaService.currentWorkArea != null && item != null && item.commandParams != null) {
                                if (workAreaService.currentWorkArea.workAreaId == item.commandParams.eWorkAreaId) {
                                    service.rowsToAdd.push({ docId: item.workAreaSI.fileId, majRev: item.workAreaSI.majRev, minRev: item.workAreaSI.minRev });

                                    // Update rec counts.
                                    service.endRecord = service.endRecord + 1;
                                    if (service.startRecord == 0)
                                        service.startRecord = 1;
                                    service.totalRecords = service.totalRecords + 1;
                                    service.onRecordCountsChanged();
                                }
                            }
                            break; // 2018-01-03
                        default: 
                            si = item.updateSI;
                            siDD = item.updateSI;
                    }

                    if (si != null)
                        service.appendItem(workAreaItem, si, siDD, recordsToUpdate, recordsToUpdateDD);

                    if (item.overwrittenFileId) {
                        var overwrittenItem = { fileId: item.overwrittenFileId, majRev: 0, minRev: 1 };
                        var overwrittenSI = { docId: "remove", majRev: "", minRev: "" };
                        var overwrittenSIDD = { docId: item.overwrittenFileId, majRev: "", minRev: "" };
                        service.appendItem(overwrittenItem, overwrittenSI, overwrittenSIDD, recordsToUpdate, recordsToUpdateDD);
                        // Update rec counts.
                        service.endRecord = service.endRecord - 1;
                        if (service.endRecord == 0)
                            service.startRecord = 0;
                        service.totalRecords = service.totalRecords - 1;
                        service.onRecordCountsChanged();
                    }
                }
                else {
                    if (item.updateMode == updateMode_Remove) {
                        si = { docId: "remove", majRev: "", minRev: "" };
                        siDD = si;

                        // Update rec counts.
                        service.endRecord = service.endRecord - 1;
                        if (service.endRecord == 0)
                            service.startRecord = 0;
                        service.totalRecords = service.totalRecords - 1;
                        service.onRecordCountsChanged();
                    }
                    else if (item.updateMode != updateMode_None) { // 2018-01-03 Don't let none through.
                        si = item.updateSI;
                        siDD = si;
                    }

                    if (si != null)
                        service.appendItem(item, si, siDD, recordsToUpdate, recordsToUpdateDD);
                }
            });


            if (service.rowsToAdd.length > 0) {
                recordsToUpdate = [];
                angular.forEach(service.rowsToAdd, function (item) {
                    recordsToUpdate.push({ newRecord: item });
                });
            }

            //angular.forEach(recordsToUpdate, function (item) {
            //    console.log("Record to Update", item)
            //});

            //// this will add new records to the workarea
            //if (service.rowsToAdd.length > 0) {
            //    var workAreaService = $injector.get('workAreaService');
            //    var workAreaId = workAreaService.currentWorkArea.workAreaId;
            //    var searchService = $injector.get('searchService');
            //    searchService.getDocsByListForWorkArea(service.rowsToAdd, workAreaId).then(function (response) {
            //        var data = response.data;
            //        angular.forEach(data.AdeptDataTable.TableRecords, function (item) {
            //            if (service.data.length === 0)
            //                service.reloadGrid();
            //            else {
            //                // New items always have a blank image
            //                item["GLYPH_TYPE"] = 'data:image/bmp;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAARCAYAAADDjbwNAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAXSURBVDhPYxgFo2AUjIJRMApGDmBgAAAG+QABYTsOvAAAAABJRU5ErkJggg==';
            //                service.data.unshift(item);
            //            }
            //        });
            //        for (var prop in data.MenuEnables) {
            //            service.menuEnables[prop] = data.MenuEnables[prop];
            //        }
            //    });
            //}


            getNewRecords(recordsToUpdate).then(function (data) {
                if (data) {
                    angular.forEach(data.AdeptDataTable.TableRecords, function (item) {
                        console.log("Updated Record:", item);
                    });
                    if (service.rowsToAdd.length > 0) {
                        angular.forEach(data.AdeptDataTable.TableRecords, function (item) {
                            if (service.data.length === 0)
                                service.reloadGrid();
                            else {
                                // New items always have a blank image
                                item["GLYPH_TYPE"] = 'data:image/bmp;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAARCAYAAADDjbwNAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAXSURBVDhPYxgFo2AUjIJRMApGDmBgAAAG+QABYTsOvAAAAABJRU5ErkJggg==';
                                service.data.unshift(item);
                            }
                        });
                        for (var prop in data.MenuEnables) {
                            service.menuEnables[prop] = data.MenuEnables[prop];
                        }
                    }

                    //Create the map of each record to update
                    var map = mapRecords(data, recordsToUpdate);
                    //replace the records in the grid using the map
                    //console.log("Replacing the records in the grid with map:", map);
                    service.replaceRecordsMain(map);
                    //update the menu enables
                    service.updateMenuEnables(data.MenuEnables);
                    //notify the grids of the change
                    notifyMain(recordsToUpdate);
                }

                //this will update the document dashboard
                getNewRecords(recordsToUpdateDD).then(function (data) {
                    if (data) {
                        //Create the map of each record to update
                        var map = mapRecords(data, recordsToUpdateDD);
                        //replace the records in the grid using the map
                        service.replaceRecordsDD(map);
                        //update the menu enables
                        service.updateMenuEnables(data.MenuEnables);
                        //notify the grids of the change
                        notifyDD(recordsToUpdateDD);
                    }
                });


            });
        }

        function getNewRecords(records) {
            var deferred = $q.defer();
            //prepare the new record keys to ask the server for the new records
            var keys = [];
            angular.forEach(records, function (item) {
                keys.push(item.newRecord);
            });

            //searchservice will get us the new records
            var searchService = $injector.get('searchService');

            // pl
            if (service.serviceIdentifier == 'workAreaService') {
                var workAreaService = $injector.get('workAreaService');
                if (workAreaService.currentWorkArea) {                  
                    var workAreaId = workAreaService.currentWorkArea.workAreaId;
                    searchService.getDocsByListForWorkArea(keys, workAreaId).then(function (response) {
                        deferred.resolve(response.data);
                    });
                }
                else {
                    deferred.resolve();
                }
                
            }
            else {
                searchService.getDocsByList(keys).then(function (response) {
                    deferred.resolve(response.data);
                });
            }
            return deferred.promise;
        }

        function mapRecords(data, recordsToUpdate) {
            if (data) {
                var records = data.AdeptDataTable.TableRecords;
                //iterate over each record and update the map with the actual record
                angular.forEach(records, function (record) {
                    //console.log("New Record:", record);
                    angular.forEach(recordsToUpdate, function (item) {
;                        if (item.newRecord.docId == record.SCHEMA_S_FILEID && item.newRecord.majRev == record.SCHEMA_S_MAJREV && item.newRecord.minRev == record.SCHEMA_S_MINREV) {
                            //console.log("Mapping to:", item);
                            item.newRecord = record;
                        }
                    });
                });
                return recordsToUpdate;
            }           
        }

        function notifyMain(records) {
            //notify the grid when a record is updated
            angular.forEach(service.data, function (item, index) {
                angular.forEach(records, function (record) {
                    if (record.newRecord.SCHEMA_S_FILEID == item.SCHEMA_S_FILEID && record.newRecord.SCHEMA_S_MAJREV == item.SCHEMA_S_MAJREV && record.newRecord.SCHEMA_S_MINREV == item.SCHEMA_S_MINREV) {
                        angular.forEach(service.updateRecordsCallbacks, function (item) {
                            item(service.data[index]);
                        });
                    }
                })
            });
        }

        function notifyDD(records) {
            //notify the dd when a record is updated
            records.forEach(function (record) {
                if (record.SCHEMA_S_FILEID) {
                    service.ddData.forEach(function (item) {

                        if (record.newRecord.SCHEMA_S_FILEID == item.SCHEMA_S_FILEID && record.newRecord.SCHEMA_S_MAJREV == item.SCHEMA_S_MAJREV && record.newRecord.SCHEMA_S_MINREV == item.SCHEMA_S_MINREV) {
                            angular.forEach(service.updateRecordsCallbacks, function (callBack) {
                                callBack(service.ddData[index]);
                            });
                        }
                    });
                }
                else {
                    angular.forEach(service.updateRecordsCallbacks, function (callBack) {
                        callBack(record);
                    });
                }
            });
        }

        //update the current menu enables
        service.updateMenuEnables = function (newMenuEnables) {
            for (var prop in newMenuEnables) {
                service.menuEnables[prop] = newMenuEnables[prop];
            }
        }

        //listener for a record selection change
        service.selectedRecordChanged = function (record) {
            service.onSelectedRecordChanged(record);
        }

        //delay the processing 1 sec to allow the UI to paint the elements.
        $timeout(function () {
            service.processing = false;
        }, 0);

        

        service.updateGridRecord = function(record) {
            if (record) {
                var recArr = [record,];
                var slx = service.BuildSLX(recArr);
                service.updateGridRecords(slx);
            }
        }

        service.BuildSLX = function(gridSelectedItems) {
            //alert('BuildSL: ' + gridSelectedItems.length + ' items selected.');

            // The main list.
            var items = [];
            var menuEnables = service.menuEnables;


            // Walk the grid's selected items.
            var len = gridSelectedItems.length;
            for (var i = 0; i < len; i++) {
                // Get this selected item.
                var gridItem = gridSelectedItems[i];
                // Buld a DI from the grid item.
                var key = gridItem.SCHEMA_S_FILEID.toUpperCase() + "." + gridItem.SCHEMA_S_MAJREV + "." + gridItem.SCHEMA_S_MINREV;
                var detailedInfo = {
                    filename: gridItem.SCHEMA_S_LONGNAME,
                    bGRev: gridItem.SCHEMA_S_GREV == "T" ? true : false,
                    opFlag: gridItem.SCHEMA_S_OPFLAG.charCodeAt(0),
                    status: gridItem.SCHEMA_S_STATUS,
                    libId: gridItem.SCHEMA_S_LIBID,
                    userId: gridItem.SCHEMA_S_USERID,
                    lastUserId: gridItem.SCHEMA_S_LSTOWNID,
                    targetId: gridItem.SCHEMA_S_PATHID,
                    workflowId: gridItem.SCHEMA_S_WFID,
                    workflowStepId: gridItem.SCHEMA_S_STEPID,
                    defaultWorkflowId: gridItem.SCHEMA_S_DEFWFID,
                    originatorID: gridItem.SCHEMA_S_ORIGID,
                    fileUtc: gridItem.SCHEMA_S_FILEUTC,
                    fileSize: gridItem.SCHEMA_S_FILESIZE,
                    linkType: gridItem.SCHEMA_S_LINKED.charCodeAt(0),
                    bIsParent: gridItem.SCHEMA_S_PARENT == "T" ? true : false,
                    bIsChild: gridItem.SCHEMA_S_CHILD == "T" ? true : false,
                    libName: gridItem.SCHEMA_S_LIBNAME,
                    activeWorkflowName: gridItem.SCHEMA_S_WFNAME,
                    activeStepName: gridItem.SCHEMA_S_STEPNAME,
                    menuEnables: menuEnables[key]
                };
                var commandParams = {};
                var docId = null;
                // Make a SI with filename, sort, dockey fields, and DI.
                var selectionItem = {
                    filename: gridItem.SCHEMA_S_LONGNAME,
                    sortval: gridItem.SCHEMA_S_LONGNAME,
                    tableNumber: +gridItem.SCHEMA_S_SRCDB,
                    fileId: gridItem.SCHEMA_S_FILEID,
                    majRev: +gridItem.SCHEMA_S_MAJREV,
                    minRev: +gridItem.SCHEMA_S_MINREV,
                    detailedInfo: detailedInfo,
                    commandParams: commandParams,
                    docId: docId
                };
                // Add to the main list.
                items.push(selectionItem);
            }
            return items;
        }

        return service;


    }

    



})();